import { useFavorites } from '../store/favorites'
import { api } from './api'

export const getFavorites = async () => {
  try {
    const { data: response } = await api.get('/documents', {
      params: {
        isFavorite: true,
        isFolder: true,
      },
    })

    useFavorites.getState().setFavorites([
      {
        name: 'Início',
        url: '/',
      },
      ...response.data,
    ])
  } catch (error) {}
}
